import { render, staticRenderFns } from "./Spielercheck.vue?vue&type=template&id=f6b5ad84&"
import script from "./Spielercheck.vue?vue&type=script&lang=js&"
export * from "./Spielercheck.vue?vue&type=script&lang=js&"
import style0 from "./Spielercheck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports